import React from "react";
import { Link } from "react-router-dom";
import { 
  ServerCrash, 
  RefreshCcw, 
  HelpCircle,
  Activity
} from "lucide-react";
import Navigation from "../components/Navigation";
import FooterSection from "../components/FooterSection";
import "./ComingSoon.css"; 

const ServerError = () => {
  return (
    <div className="se-portal server-error">
      <Navigation />
      <div className="glass-overlay pink-haze"></div>
      
      <main className="coming-soon-content">
        <div className="hero-section">
          <div className="badge-wrapper animate-fade-in">
            <div className="badge pink">
              <ServerCrash size={16} className="icon-pink" />
              <span>System Error 500</span>
            </div>
          </div>

          <h1 className="hero-title animate-slide-up">
            Our Servers are <span className="highlight pink">Degraded</span>
          </h1>
          
          <p className="hero-subtitle animate-slide-up delay-1">
            We are experiencing unexpected technical difficulties. Our engineering team has been notified and is investigating the anomaly.
          </p>

          <div className="actions-row animate-slide-up delay-2">
            <button 
              className="premium-btn primary"
              onClick={() => window.location.reload()}
            >
              <RefreshCcw size={20} />
              Retry Connection
            </button>
            <Link to="/status">
              <button className="premium-btn secondary">
                <Activity size={20} />
                System Status
              </button>
            </Link>
          </div>
        </div>
      </main>
      <FooterSection />
    </div>
  );
};

export default ServerError;
